import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { COMPARISON } from '../lib/constants';
// Compact side-by-side comparison — fits without scrolling.
export function ComparisonSection() {
  return <section className="px-5 py-8" data-id="element-52">
      <div className="mx-auto max-w-md" data-id="element-53">
        <h2 className="text-center font-[Montserrat] text-lg font-extrabold leading-snug text-white" data-id="element-54">
          Sin Licencia de navegación resuelta{' '}
          <span className="text-slate-400" data-id="element-55">vs</span>{' '}
          <span className="text-[#e6c168]" data-id="element-56">
            Con Licencia de navegación resuelta
          </span>
        </h2>

        <div className="mt-5 grid grid-cols-2 gap-2" data-id="element-57">
          {/* Without */}
          <div className="overflow-hidden rounded-xl border border-red-400/30 bg-red-950/30" data-id="element-58">
            <div className="bg-red-500/20 px-2 py-2 text-center text-[11px] font-extrabold uppercase tracking-tight text-red-200" data-id="element-59">
              Sin resolver
            </div>
            <ul className="divide-y divide-white/5" data-id="element-60">
              {COMPARISON.map((row, i) => <li key={i} className="flex items-start gap-1.5 px-2 py-2 text-[11px] leading-tight text-red-100" data-id="element-61">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 flex-none text-red-400" aria-hidden="true" data-id="element-62" />
                  <span data-id="element-63">{row.without}</span>
                </li>)}
            </ul>
          </div>

          {/* With */}
          <div className="overflow-hidden rounded-xl border border-emerald-400/40 bg-emerald-950/30 ring-1 ring-[#c8a24a]/30" data-id="element-64">
            <div className="bg-emerald-500/20 px-2 py-2 text-center text-[11px] font-extrabold uppercase tracking-tight text-emerald-200" data-id="element-65">
              Con el Pack
            </div>
            <ul className="divide-y divide-white/5" data-id="element-66">
              {COMPARISON.map((row, i) => <li key={i} className="flex items-start gap-1.5 px-2 py-2 text-[11px] leading-tight text-emerald-50" data-id="element-67">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 flex-none text-emerald-400" aria-hidden="true" data-id="element-68" />
                  <span data-id="element-69">{row.with}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}